var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardDoubleArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.064 32.6875C105.626 30.25 101.689 30.25 99.2515 32.6875L75.0015 56.875L50.689 32.625C48.2515 30.1875 44.314 30.1875 41.8765 32.625C39.439 35.0625 39.439 39 41.8765 41.4375L70.564 70.125C73.0015 72.5625 76.939 72.5625 79.3765 70.125L108.064 41.4375C110.501 39.0625 110.501 35.125 108.064 32.6875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.063 73.8755C105.625 71.438 101.688 71.438 99.2502 73.8755L75.0002 98.063L50.7502 73.813C48.3127 71.3755 44.3752 71.3755 41.9377 73.813C39.5002 76.2505 39.5002 80.188 41.9377 82.6255L70.6252 111.313C73.0627 113.75 77.0002 113.75 79.4377 111.313L108.125 82.6255C110.5 80.2505 110.5 76.313 108.063 73.8755Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_down.f66bd897.svg";
export { ForwardRef as ReactComponent };